var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"call_to_book -text-blue",attrs:{"href":'tel:' + _vm.phone}},[_c('span',{staticClass:"no_wrap"},[_vm._v("Call to book")]),_c('br'),_c('small',{staticClass:"text-blue"},[_vm._v(_vm._s(_vm.phone))])])
}
var staticRenderFns = []

export { render, staticRenderFns }